import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="keep-form"
export default class extends Controller {
  // allRequireButton: 全ての項目が必須の時に活性化となるボタン
  static targets = ['input', 'submitButton', 'allRequireButton']
  static values = {
    sessionClearFlag: Boolean,
    storageKey: String,
    initialValues: Object
  }

  initialize() {
    if (this.sessionClearFlagValue) {
      this.sessionClear()
    }

    if (!this.getAlreadyCheckValues()) {
      sessionStorage.setItem(this.storageKeyValue, JSON.stringify(this.initialValuesValue))
    }
    this.setInitialDisplay()
    this.propDisabled()
  }

  // 保持しているキーに対して値がセットされているかを確認する
  judgeAllInput() {
    const storageValues = this.getAlreadyCheckValues()
    for (let dataValues of Object.values(storageValues)) {
      for (let dataValue of Object.values(dataValues)) {
        for (let value of Object.values(dataValue)) {
          if (!value) {
            return false
          }
        }
      }
    }
    return true
  }

  propDisabled() {
    if (!this.hasInputTarget) {
      this.submitButtonTargets.forEach(element => {
        element.disabled = true
      })
      return
    }

    if (this.hasAllRequireButtonTarget) {
      const enable = this.judgeAllInput()
      this.allRequireButtonTargets.forEach(element => {
        element.disabled = !enable
      })
    }
  }

  changeInput(event) {
    this.addStorageValues(event.target.dataset.name, event.target.dataset.id, event.target.name, event.target.value)
    this.propDisabled()
  }

  addStorageValues(dataName, dataId, key, value) {
    const alreadySelectedValues = this.getAlreadyCheckValues()
    if (alreadySelectedValues) {
      if (alreadySelectedValues[dataName]) {
        if (alreadySelectedValues[dataName][dataId]) {
          alreadySelectedValues[dataName][dataId][key] = value
        } else {
          alreadySelectedValues[dataName][dataId] = { [key]: value }
        }
      } else {
        alreadySelectedValues[dataName] = { [dataId]: { [key]: value } }
      }
      sessionStorage.setItem(this.storageKeyValue, JSON.stringify(alreadySelectedValues))
    } else {
      const obj = { [dataName]: { [dataId]: { [key]: value } } }
      sessionStorage.setItem(this.storageKeyValue, JSON.stringify(obj))
    }
  }

  // 保持している値から、input要素に値をセットする処理
  setInitialDisplay() {
    const storageValues = this.getAlreadyCheckValues()
    const inputElements = this.inputTargets
    if (storageValues) {
      for (const inputElemnt of inputElements) {
        if (!storageValues[inputElemnt.dataset.name]) {
          continue
        }

        const storageValue = storageValues[inputElemnt.dataset.name][inputElemnt.dataset.id]
        if (storageValue && storageValue[inputElemnt.name]) {
          inputElemnt.value = storageValue[inputElemnt.name]
        }
      }
    }
  }

  getAlreadyCheckValues() {
    // sessionStorageに保存している値（ハッシュ）
    return JSON.parse(sessionStorage.getItem(this.storageKeyValue))
  }

  submitSettingForm(event) {
    event.preventDefault()
    // buttonタグの中のspanタグがevent.targetとして返ることがあるのでボタンタグを取得
    const button = (event.target.tagName === 'BUTTON') ? event.target : event.target.closest('button')

    const storageValues = this.getAlreadyCheckValues()
    if (!storageValues) {
      return
    }

    for (let [dataName, dataValues] of Object.entries(storageValues)) {
      for (let [id, dataValue] of Object.entries(dataValues)) {
        for (let [key, value] of Object.entries(dataValue)) {
          //input要素を生成
          const input = document.createElement('input')
          //input要素に属性を設定
          Object.assign(input, {
              type: 'hidden',
              name: `${button.form.id}[${dataName}_attributes][${id}][${key}]`,
              value: value,
          })
          button.form.appendChild(input)
        }
      }
    }
    button.form.submit()
    button.disabled = true
  }

  sessionClear() {
    sessionStorage.removeItem(this.storageKeyValue)
  }
}
